import { Injectable, Signal, signal } from '@angular/core';
import { ApiService } from './api.service';
import { CatalogData, Linea } from '../models/catalog.model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {
  private productos = signal<any[]>([]);
  private loaded = signal(false);
  private loading = signal(false);
  private categorias = signal<any[]>([]);
  private lineas = signal<Linea[]>([]);

  constructor(private apiService: ApiService) {
    // Cargar productos al inicializar el servicio
    this.loadProductos();
  }

  /**
   * Carga los productos desde la API falsa
   */
  private loadProductos(): void {
    if (this.loaded() || this.loading()) return;
    
    this.loading.set(true);
    this.apiService.getCatalog().subscribe({
      next: (catalog: CatalogData) => {
        const orderedLineas = [...catalog.lineas]
          .filter(linea => linea.activa !== false)
          .sort((a, b) => a.orden - b.orden);

        this.productos.set(catalog.productos);
        this.categorias.set(catalog.categorias);
        this.lineas.set(orderedLineas);
        this.loaded.set(true);
        this.loading.set(false);
      },
      error: (error) => {
        console.error('Error al cargar productos:', error);
        this.productos.set([]);
        this.categorias.set([]);
        this.lineas.set([]);
        this.loading.set(false);
      }
    });
  }

  /**
   * Verifica si los productos están cargados
   */
  isLoaded(): boolean {
    return this.loaded();
  }

  /**
   * Obtiene todos los productos (síncrono desde caché)
   */
  getAllProductos(): any[] {
    return this.productos();
  }

  /**
   * Obtiene las categorías del catálogo (ordenadas)
   */
  getCategorias(): any[] {
    return this.categorias();
  }

  getCategoriasSignal(): Signal<any[]> {
    return this.categorias.asReadonly();
  }

  /**
   * Obtiene las líneas del catálogo (ordenadas)
   */
  getLineas(): Linea[] {
    return this.lineas();
  }

  getLineasSignal(): Signal<Linea[]> {
    return this.lineas.asReadonly();
  }

  /**
   * Obtiene productos como Observable (para usar directamente con la API)
   */
  getProductos$() {
    return this.apiService.getCatalog().pipe(map((catalog) => catalog.productos));
  }

  /**
   * Obtiene productos por línea (slug)
   */
  getProductosByLinea(lineaSlug: string): any[] {
    return this.productos().filter(producto => producto.lineaSlug === lineaSlug);
  }

  /**
   * Obtiene una línea por su slug
   */
  getLineaBySlug(lineaSlug: string): Linea | undefined {
    return this.lineas().find(linea => linea.lineaSlug === lineaSlug);
  }
}

